module.exports = require("@swa-ui/core/src/Overlay/Overlay.module.scss");